let descriptionIntegrityKey = ''
let encryptionKey = ''
let fetchPromise = null

export const getDescriptionIntegrityKey = () => descriptionIntegrityKey

export const getEncryptionKey = () => encryptionKey

export const setAuthKeys = ({ offerssKey, encryptionKey: encKey }) => {
  descriptionIntegrityKey = offerssKey || ''
  encryptionKey = encKey || ''
}

export const areAuthKeysEmpty = () =>
  !descriptionIntegrityKey || !encryptionKey

export const clearAuthKeys = () => {
  descriptionIntegrityKey = ''
  encryptionKey = ''
  fetchPromise = null
}

export const getFetchPromise = () => fetchPromise

export const setFetchPromise = (promise) => {
  fetchPromise = promise
}

export const clearFetchPromise = () => {
  fetchPromise = null
}
